"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.group.dashboards.view", {
        url:
            "/:period/:date?source&startDate&comparationDate&comparationPeriod&otherPeriod&scenario&scenarioCompare&filterGroup",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-accounting-company-dashboards" */ "../../company/dashboards/dashboards.entry"
            ).then(() =>
                $ocLazyLoad.inject("nucont.accounting.company.dashboards")
            );
        },
        params: {
            comparationDate: { value: null, dynamic: true },
            source: { value: null, dynamic: true },
            startDate: { value: null, dynamic: true },
            comparationPeriod: { value: null, dynamic: true },
            otherPeriod: { value: null, dynamic: true },
            date: { value: null, dynamic: true },
            period: { value: null, dynamic: true },
            scenario: { value: null, dynamic: true },
            scenarioCompare: { value: null, dynamic: true },
            filterGroup: { value: null, dynamic: true }
        },
        views: {
            "admin@nucont.accounting": {
                component: "dashboardsComponent",
                bindings: { companyData: "groupData" }
            }
        },
        data: {
            layoutConfig: {
                model: "LayoutConfigModel5",
                ignore: { object: "headerConfig", path: "title" }
            }
        }
    });
}
